import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import ChatPanel from './ChatPanel';
import ConversationList from './ConversationList';
import { ConversationsProvider } from '../../contexts/ConversationsContext';

const IndividualMessages = ({
  auth,
}) => {
  const location = useLocation();
  const selectedConversationId = new URLSearchParams(location.search).get('id') || null;

  return(
    <div style={{height: '100%', display: 'flex', flexDirection: 'row'}}>
      <ConversationsProvider selectedConversationId={selectedConversationId} >
        <ConversationList/>
        <ChatPanel
          auth={ auth }
          authorId={parseInt(auth.id)}/>
      </ConversationsProvider>
    </div>
  );
}

IndividualMessages.propTypes = {
  auth: PropTypes.object.isRequired,
};

IndividualMessages.mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(IndividualMessages.mapStateToProps, {})(IndividualMessages);
